import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { Routes } from "../../../../routes/Routes";
import { texts } from "../../../../i18n/texts";

/**
 * Breadcrumb name loader for the admin view root.
 */
@BreadcrumbLoader(Routes.adminView.toPath())
export class AdminViewBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.adminView;
}
